"use client";

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchOrganizationMetricMedicines, type OrganizationMetric, type OrganizationMetricSortBy, type OrganizationMetricSortDir } from "@/entities/organization/api/organization-metric-drilldown";
import type { OrganizationRegion } from "@/shared/config/constants";
const FIVE_MINUTES = 5 * 60 * 1000;
export function useOrganizationMetricDrilldownQuery(params) {
  const $ = _c(26);
  const {
    organizationId,
    metric,
    region,
    paymentPercentage,
    search,
    sortBy,
    sortDir,
    page,
    limit
  } = params;
  let t0;
  if ($[0] !== search) {
    t0 = search.trim();
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const trimmedSearch = t0;
  const t1 = region ?? "all";
  let t2;
  if ($[2] !== limit || $[3] !== metric || $[4] !== organizationId || $[5] !== page || $[6] !== paymentPercentage || $[7] !== sortBy || $[8] !== sortDir || $[9] !== t1 || $[10] !== trimmedSearch) {
    t2 = ["analytics", "organization-rankings", "medicines", organizationId, metric, t1, paymentPercentage, trimmedSearch, sortBy, sortDir, page, limit];
    $[2] = limit;
    $[3] = metric;
    $[4] = organizationId;
    $[5] = page;
    $[6] = paymentPercentage;
    $[7] = sortBy;
    $[8] = sortDir;
    $[9] = t1;
    $[10] = trimmedSearch;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const t3 = organizationId != null && metric != null;
  let t4;
  if ($[12] !== limit || $[13] !== metric || $[14] !== organizationId || $[15] !== page || $[16] !== paymentPercentage || $[17] !== region || $[18] !== sortBy || $[19] !== sortDir || $[20] !== trimmedSearch) {
    t4 = () => fetchOrganizationMetricMedicines({
      organizationId: organizationId as string,
      metric: metric as OrganizationMetric,
      region,
      payment_percentage: paymentPercentage,
      search: trimmedSearch,
      sort_by: sortBy,
      sort_dir: sortDir,
      page,
      limit
    });
    $[12] = limit;
    $[13] = metric;
    $[14] = organizationId;
    $[15] = page;
    $[16] = paymentPercentage;
    $[17] = region;
    $[18] = sortBy;
    $[19] = sortDir;
    $[20] = trimmedSearch;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4) {
    t5 = {
      queryKey: t2,
      staleTime: FIVE_MINUTES,
      placeholderData: keepPreviousData,
      enabled: t3,
      queryFn: t4
    };
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return useQuery(t5);
}